import React from 'react';
import { addFontFamilyInherit, parseStyle, stringCss } from '../../../util/parseStyle';

type Props = {
  contentId: number;
  contentIndex: number;
  startEditing: () => void;
  style: any;
  editedText: string;
  contentCategory: string;
  commonStyle: any;
};

function TextEditCover({ contentId, contentIndex, startEditing, style, editedText, contentCategory, commonStyle }: Props) {

  return (
    <>
    <div 
      className={`text-edit-cover text-edit-content-${contentId}${contentIndex}`}
      onClick={startEditing}
      style={parseStyle(style)}
    >
      {
        editedText && (
          <div
            style={parseStyle(style)}
            dangerouslySetInnerHTML={{ __html: addFontFamilyInherit(editedText) }}
          />
        )
      }
    </div>
    <style>
      {
        `.text-edit-content-${contentId}${contentIndex} 
        a ${stringCss(commonStyle.link)} 
        .text-edit-content-${contentId}${contentIndex} 
        span > a {font-weight:inherit; font-style:inherit;text-decoration:inherit;}`
      }
    </style>
  </>
  );
}

TextEditCover.defaultProps = {
};

export default TextEditCover;